const PNG_SIGNATURE = new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10]);

export const isPng = (array: Uint8Array): boolean => {

    if (array.length < PNG_SIGNATURE.length) {
        return false;
    }

    for (let i = 0; i < PNG_SIGNATURE.length; i++) {
        if (array[i] !== PNG_SIGNATURE[i]) {
            return false;
        }
    }

    return true;
};